<template lang="pug">
#modal-confirmacao-pre-analise-credito
    el-dialog(
        title='Realizar Pré-Análise de análise de crédito',
        :width='width',
        :visible.sync='show_',
        :close-on-click-modal='false',
        :destroy-on-close='true',
        :show-close='false',
        custom-class='no-box-shadow',
        show-close,
        @close='closeDialog()'
    )
        div(style='display: flex; flex-direction: column')
            .text-left
                span.font-weight-normal.ml-1
                    | {{ $t('mensagens.home.pesquisaInteligente.preAnaliseModal.voceOptouPorRealizarUmaConsulta') }}

            .text-left
                span.font-weight-normal.ml-1
                    | {{ $t('mensagens.home.pesquisaInteligente.preAnaliseModal.paraO') }} {{ cpfCnpj.length > 11 ? 'CNPJ' : 'CPF' }}
                span.font-bold
                    | &nbsp;{{ numeralStringFormatTocpfCnpj(cpfCnpj) }}.

            .text-left.mt-2
                span.font-weight-normal.ml-1
                    | {{ $t('mensagens.home.pesquisaInteligente.preAnaliseModal.aoRealizarProcesso') }}

            .text-left.mt-2.mb-2
                span.font-weight-normal.ml-1
                    | {{ $t('mensagens.home.pesquisaInteligente.preAnaliseModal.voceDesejaContinuar') }}

        .dialog-footer(slot='footer', v-if='mostrarBotaoVoltar')
            BaseButton(@click='closeDialog()') {{ $t('mensagens.comuns.cancelar') }}
            BaseButton(type='primary', @click='$emit("processar")') {{ $t('mensagens.comuns.continuar') }}
</template>

<script>
import formatters from '@/utils/formatters';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'ModalConfirmacaoPreAnaliseCredito',

    components: {
        BaseButton
    },

    props: {
        show: {
            type: Boolean,
            default: false,
            required: true
        },
        width: {
            type: String,
            default: '500px'
        },
        mostrarBotaoVoltar: {
            type: Boolean,
            default: true
        },
        cpfCnpj: {
            type: String,
            default: ''
        }
    },

    data() {
        return {
            show_: false
        };
    },

    watch: {
        show: {
            handler() {
                this.show_ = this.show;
            },
            immediate: true
        }
    },

    methods: {
        closeDialog() {
            this.show_ = false;
            this.$emit('closeDialog');
        },
        numeralStringFormatTocpfCnpj(cpfCnpj) {
            return formatters.numeralStringFormatToDocumento(cpfCnpj);
        }
    }
};
</script>

<style lang="scss">
#modal-confirmacao-pre-analise-credito {
    .el-dialog__footer {
        margin-top: 0px;
        text-align: right;
        border-top: solid 2px #e7e7e7;
        background-color: #ffffff;

        .dialog-footer {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
        }
    }

    .el-dialog__close {
        color: #3B3B3B;
        &:before {
            font-size: 20px;
            font-weight: 600;
        }
    }

    .modal-text {
        font-family: 'Roboto', 'sans serif';
        font-size: 14px;
        font-weight: 500;
        line-height: 16px;
        letter-spacing: 0em;
        text-align: left;
        padding-bottom: 8px;
    }

    .el-dialog__body {
        max-height: 525px;
        overflow-y: auto;
    }

    .el-dialog__body {
        padding: 20px;
        background-color: #ffffff;
        padding-bottom: 0;
        span {
            color: #3b3b3b;
        }
    }

    .el-dialog__header {
        background-color: #e9e9e9;
        .el-dialog__title {
            color: #00413c;
            font-weight: 600;
            font-size: 18px;
            line-height: 22px;
        }
    }

    .font-bold {
        font-weight: 600;
    }

    .el-divider--horizontal {
        margin: 15px 0 8px 0;
    }
}
</style>
